import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import alertIcon from '../../assets/alert.png';
import leftArrow from '../../assets/left-arrow.png';
import rightArrow from '../../assets/right-arrow.png';
import api from '../../../api';

// import './alerts.scss';

const fetchAlertData = async () => {
  const alerts = await api.getAlerts();

  // return data in 2 seconds
  return new Promise((res) => {
    setTimeout(() => {
      res(
        alerts.map((alert) => ({
          title: alert.title?.rendered,
          message: alert.acf?.alert_content,
        }))
      );
    }, 2000);
  });
};

const nextAlertIndex = ({ total, current }) => {
  let nextIndex = current + 1;
  if (nextIndex > total - 1) {
    nextIndex = 0;
  }
  return nextIndex;
};

const prevAlertIndex = ({ total, current }) => {
  let nextIndex = current - 1;
  if (nextIndex < 0) {
    nextIndex = total - 1;
  }
  return nextIndex;
};

const Alerts = () => {
  const [alerts, setAlerts] = useState([]);
  const [currentAlertIndex, setCurrentAlertIndex] = useState(0);

  // Refactor function inside useEffect to prevent eslint warning and infinte loop
  useEffect(() => {
    const fetchAlerts = async () => {
      const alertData = await fetchAlertData();
      if (alertData.length > 0) {
        setAlerts(alertData);
      }
    };
    fetchAlerts();
  }, [setAlerts]);

  const wrapperClasses = classNames(
    'w-full bg-accent h-0 opacity-0 transition-all duration-300',
    {
      'py-4 opacity-100 h-auto': alerts.length > 0,
    }
  );

  return (
    <div className={wrapperClasses}>
      <div
        className={`container mx-auto flex justify-between items-center flex-col md:flex-row`}
      >
        <div>
          <img src={alertIcon} alt="alert icon" />
        </div>
        <div className="text-center mx-2 max-w-xl">
          <div
            className="py-4 md:py-0 max-w-4xl"
            dangerouslySetInnerHTML={{
              __html: alerts[currentAlertIndex]?.message,
            }}
          />
        </div>
        <div className="flex justify-between">
          <img
            className="cursor-pointer"
            src={leftArrow}
            alt="left arrow"
            onClick={() => {
              setCurrentAlertIndex(
                prevAlertIndex({
                  total: alerts.length,
                  current: currentAlertIndex,
                })
              );
            }}
          />
          <span className="px-4 flex items-center">{`${
            currentAlertIndex + 1
          } of ${alerts.length}`}</span>
          <img
            className="cursor-pointer"
            src={rightArrow}
            alt="right arrow"
            onClick={() => {
              setCurrentAlertIndex(
                nextAlertIndex({
                  total: alerts.length,
                  current: currentAlertIndex,
                })
              );
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Alerts;
